import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TrendStatisticResponse} from '@npck/af-frontend-api';
import {LocalizationService, Spinner} from '@npck/libs/commons';
import {TrendStatisticForm} from '../trend-statistic/trend-statistic.component';

@Component({
    selector: 'af-trend-statistic-expansion-panel',
    templateUrl: './trend-statistic-expansion-panel.component.html',
    styleUrl: './trend-statistic-expansion-panel.component.scss',
    standalone: false
})
export class TrendStatisticExpansionPanelComponent {
    @Input() trendStatistic: TrendStatisticResponse;
    @Input() trendStatisticForm: FormGroup<TrendStatisticForm>;
    @Input() showDeleteButton: boolean;
    @Input() index: number;
    @Input() viewIndex: number | string;
    @Output() deleteTrendStatisticListener = new EventEmitter<number>();
    Spinner = Spinner;
    private _expanded = false;
    private wasExpanded = false;

    constructor(
        private localizationService: LocalizationService,
    ) {
    }

    get expanded(): boolean {
        return this._expanded;
    }

    @Input()
    set expanded(value: boolean) {
        if (value) {
            this._expanded = true;
            this.wasExpanded = true;
        } else {
            if (!this.wasExpanded) {
                this._expanded = false;
            }
        }
    }

    getTrendStatisticTitle = (): string => {
        return this.localizationService.getLocalizedKey('i18n_af_labelTrendStatisticTitle', {
            index: this.trendStatistic?.id ?? `№${this.viewIndex}`,
        });
    };
}
